import { render, staticRenderFns } from "./DragAndDropEditColumnsList.vue?vue&type=template&id=09b6b2d3&scoped=true&"
import script from "./DragAndDropEditColumnsList.vue?vue&type=script&lang=js&"
export * from "./DragAndDropEditColumnsList.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDropEditColumnsList.vue?vue&type=style&index=0&id=09b6b2d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b6b2d3",
  null
  
)

export default component.exports